import * as React from 'react';
import NavItem from './NavItem';
import { SecurityRoles as roles } from '../../common/utils';

interface CustomerNavBar {
	onClick?: () => void;
	rolesRequired?: Array<roles>;
	currentUser: UserDetails;
}
const CustomerNavBar: React.StatelessComponent<CustomerNavBar> = props => {
	const currentRoles: Array<roles> = props.currentUser.role as any;
	const customerAuthProps = { rolesRequired: props.rolesRequired, currentRoles };

	const isAuthorized =
		props.currentUser.isAuthenticated
		&& (
			!Array.isArray(props.rolesRequired)
			|| props.rolesRequired.length === 0
			|| props.rolesRequired.some(role => Array.isArray(currentRoles) && currentRoles.indexOf(role) >= 0)
		);

	return isAuthorized ? (
		<ul className="navbar-nav navbar-nav-separator ml-xl-auto">
			<NavItem to="/user" {...customerAuthProps} onClick={props.onClick} linkExactActive={true}>
				Home
			</NavItem>
			<NavItem to={`/user/${props.currentUser.id}/policies`} {...customerAuthProps} onClick={props.onClick}>
				Your policies
			</NavItem>
			<NavItem to={`/user/${props.currentUser.id}/beneficiaries`} {...customerAuthProps} onClick={props.onClick}>
				Beneficiaries
			</NavItem>
			<NavItem to={`/user/${props.currentUser.id}/profile`} {...customerAuthProps} onClick={props.onClick}>
				Contact info
			</NavItem>
			<NavItem to={`/user/${props.currentUser.id}/billing`} {...customerAuthProps} onClick={props.onClick}>
				Billing
			</NavItem>
			<NavItem to={`/user/${props.currentUser.id}/refer`} {...customerAuthProps} onClick={props.onClick}>
				Referral
			</NavItem>
			<NavItem to="/claims" {...customerAuthProps} onClick={props.onClick}>
				File a claim
			</NavItem>
		</ul>
	) : ((null));
};
export default CustomerNavBar;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/navigation/CustomerNavBar.tsx